import React, { useEffect } from 'react'
import Topbar from '../Topbar'
import Footer from '../homepage/Footer'
import Navbar from '../homepage/Navbar'
import image from '../../assestss/terms-banner.jpg'

export default function TermsandCondition() {

useEffect(()=>{
window.scrollTo(0,0)
},[])
    return (
        <div>
            <Topbar />
            <Navbar />
            <>
                <section
                    className="bannerBg"
                    style={{ backgroundImage: `url(${image}` }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1>Terms and Condition</h1>
                                <h5>
                                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. illo quae
                                    vero{" "}
                                </h5>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="contentTerms">
                    <div className="container">
                        <div className="row">
                            <h4 className='text-center fw-bold mt-3 mb-4'>ASIA DIRECT.AFRICA TERMS AND CONDITION</h4>
                            <div className="col-lg-12">
                                <p>
                                    Welcome to Asia Direct.Africa (Pty) Ltd’s Website. We are delighted
                                    to extend our range services to you the client. The provision of our
                                    services is subject to this terms and conditions. In using our
                                    website you agree to be bound by these terms and conditions. Kindly
                                    peruse the terms and conditions carefully as they contain vital
                                    information relating to the use of the site.
                                </p>
                                <h4>Use of Site</h4>
                                <ul>
                                    <li>
                                        We hereby grant you a limited, revocable license to access and
                                        make personal use of the website as our member. However, you are
                                        not permitted to
                                    </li>
                                    <li>
                                        reproduce, duplicate, copy, sell or otherwise exploit the website
                                        or any product image, product listing, product description, price,
                                        page layout, page design, trade dress, trademark, logo or other
                                        content ("Website Content") for any commercial purpose, except as
                                        expressly provided;
                                    </li>
                                    <li>
                                        use a robot, spider or data mining or extraction tool or process
                                        to monitor, extract or copy Website Content (except in the
                                        operation or use of internet "search engines," hit counters or
                                        similar technology);
                                    </li>
                                    <li>
                                        use any meta tags, search terms, key terms, or the like that
                                        contain the website's name or trademarks used on the website
                                    </li>
                                    <li>
                                        engage in any activity that interferes with the website or another
                                        user's ability to use the website
                                    </li>
                                    <li>
                                        modify, create derivative works from, reverse engineer, decompile
                                        or disassemble any technology used to provide the website and the
                                        services offered on the website; o
                                    </li>
                                    <li>
                                        assist or encourage any third party in engaging in any activity
                                        prohibited by these Terms of Use.
                                    </li>
                                    <li>
                                        All personal information such as passwords, and any activity on
                                        the member’s account shall be the sole responsibility of that
                                        member.
                                    </li>
                                    <li>
                                        Unauthorized use of this site and/or the materials contained on
                                        this site may violate applicable copyright, trademark or other
                                        intellectual property laws or other laws.
                                    </li>
                                </ul>
                                <h4>Disclaimer of Warranty</h4>
                                <ul>
                                    <li>
                                        The contents of this site are provided “as is” without warranty of
                                        any kind, either expressed or implied, including but not limited
                                        to warranties of merchantability, fitness for a purpose and non-
                                        infringement.
                                    </li>
                                    <li>
                                        The owner of this site, the authors of these contents and in
                                        general anybody connected to this site in any way, from now on
                                        collectively called “Providers”, assume no responsibility for
                                        errors or omissions in these contents
                                    </li>
                                    <li>
                                        WebsightSEO do not accept responsibility that the website, its
                                        servers, or e-mail sent from the website are free of viruses or
                                        other harmful components. WebsightSEO will not be liable for any
                                        damages of any kind arising from the use of the website,
                                        including, but not limited to direct, indirect, incidental,
                                        punitive or consequential damages.
                                    </li>
                                    <li>
                                        The Providers further do not warrant, guarantee or make any
                                        representation regarding the safety, reliability, accuracy,
                                        correctness or completeness of these contents. The Providers shall
                                        not be ASIA DIRECT.AFRICA TERMS AND CONDITIONS Welcome to Asia
                                        Direct.Africa (Pty) Ltd’s Website. We are delighted to extend our
                                        range services to you the client. The provision of our services is
                                        subject to this terms and conditions. In using our website you
                                        agree to be bound by these terms and conditions. Kindly peruse the
                                        terms and conditions carefully as they contain vital information
                                        relating to the use of the site. liable for any direct, indirect,
                                        general, special, incidental or consequential damages (including -
                                        without limitation- data loss, lost revenues and lost profit)
                                        which may result from the inability to use or the correct or
                                        incorrect use, abuse, or misuse of these contents, even if the
                                        Providers have been informed of the possibilities of such damages.
                                        The Providers cannot assume any obligation or responsibility
                                    </li>
                                    <li>
                                        The use of these contents is forbidden in those places where the
                                        law does not allow this disclaimer to take full effect.
                                    </li>
                                </ul>
                                <h4>Asia Direct Africa’s Rights</h4>
                                <ul>
                                    <li>We reserve the right to:</li>
                                    <li>
                                        modify or withdraw, temporarily or permanently, the Website (or
                                        any part of it) with or without notice to you and you confirm that
                                        we shall not be liable to you or any third party for any
                                        modification to or withdrawal of the Website
                                    </li>
                                    <li>
                                        We will use our reasonable endeavours to maintain the Website. The
                                        Website is subject to change from time to time. You will not be
                                        eligible for any compensation because you cannot use any part of
                                        the Website or because of a failure, suspension or withdrawal of
                                        all or part of the Website due to circumstances beyond our control
                                    </li>
                                </ul>
                                <h4>Electronic Communications</h4>
                                <p>
                                    You consent to receive communications from us by e-mail. You agree
                                    that all agreements, notices, disclosures and other communications
                                    that we provide to you by e-mail satisfy any legal requirement that
                                    such communications be in writing.
                                </p>
                                <h4>Privacy Policy</h4>
                                <ul>
                                    <li>
                                        We are committed to protecting your privacy. This privacy policy
                                        applies to all the web pages related to this website. The Privacy
                                        Policy is on our website, kindly go through it so you can
                                        understand what is done with the information you are supplying to
                                        Asia Direct.Africa
                                    </li>
                                    <li>
                                        All the information gathered in the online forums on the website
                                        is used to personally identify members that subscribe to this
                                        service. The information will not be used for anything other than
                                        which is stated in the Terms &amp; Conditions of use for this
                                        service. None of the information will be sold or made available to
                                        anyone.
                                    </li>
                                    <li>
                                        The Site may collect certain information about your visit, such as
                                        the name of the Internet service provider and the Internet
                                        Protocol (IP) address through which you access the Internet; the
                                        date and time you access the Site; the pages that you access while
                                        at the Site and the Internet address of the Web site from which
                                        you linked directly to our site. This information is used to help
                                        improve the Site, analyse trends, and administer the Site
                                    </li>
                                    <li>
                                        We may need to change this policy from time to time in order to
                                        address new issues and reflect changes on our site. We will post
                                        those changes here so that you will always know what information
                                        we gather, how we might use that information, and whether we will
                                        disclose that information to anyone. Please refer to this policy
                                        regularly. If you have any questions or concerns about our privacy
                                        policy, please send us an Email: info@asiadirect.africa
                                    </li>
                                    <li>
                                        By using this website, you signify your acceptance of our Privacy
                                        Policy. If you do not agree to this policy, please do not use our
                                        site. Your continued use of the website following the posting of
                                        changes to these terms will mean that you accept those changes
                                    </li>
                                    <h4>Cookie/Tracking Technology</h4>
                                    <p>
                                        The Site may use cookie and tracking technology depending on the
                                        features offered. Cookie and tracking technology are useful for
                                        gathering information such as browser type and operating system,
                                        tracking the number of visitors to the Site, and understanding how
                                        visitors use the Site. Cookies can also help customize the Site
                                        for visitors. Personal information cannot be collected via cookies
                                        and other tracking technology; however, if you previously provided
                                        personally identifiable information, cookies may be tied to such
                                        information. Aggregate cookie and tracking information may be
                                        shared with third parties
                                    </p>
                                    <h4>Copyright</h4>
                                    <p>
                                        All Website Content is our property or the property of our content
                                        suppliers and is protected by copyright laws. All Website Content
                                        that is not our property is used with permission. The arrangement
                                        and compilation of all Website Content is our exclusive property
                                        and is protected by copyright laws. All software used on the
                                        website is our property or the property of our software suppliers
                                        and is protected by international copyright laws.{" "}
                                    </p>
                                    <h4>Trademarks</h4>
                                    <p>
                                        Certain graphics, logos, page headers, button icons, scripts, and
                                        service names are trademarks, service marks, or trade dress of our
                                        company or our affiliated companies. Our trademarks and trade
                                        dress may not be used for any commercial or other purposes without
                                        our prior written consent
                                    </p>
                                    <h4>Copyright &amp; Trademark Compliance; Complaints</h4>
                                    <p>
                                        We honour the intellectual property rights of others. If you
                                        believe that your work has been copied or used on the website in a
                                        way that constitutes copyright or trademark infringement, please
                                        notify immediately. Except in limited instances under authorized
                                        agreements, we do not reproduce or manufacture the products
                                        offered on our site, but rather we purchase or license products
                                        from third party suppliers that represent to us that they have
                                        sufficient rights to allow us to display and sell the products on
                                        the website. Upon receipt of any bona fide claim of infringement,
                                        or upon becoming aware 6.4 We may need to change this policy from
                                        time to time in order to address new issues and reflect changes on
                                        our site. We will post those changes here so that you will always
                                        know what information we gather, how we might use that
                                        information, and whether we will disclose that information to
                                        anyone. Please refer to this policy regularly. If you have any
                                        questions or concerns about our privacy policy, please send us an
                                        Email: info@asiadirect.africa of any actual or alleged
                                        infringement by any other means, we will remove such actual or
                                        alleged infringing product(s) from the website and/or cease sales
                                        of the product(s) pending our investigation.
                                    </p>
                                    <h4>Monitoring</h4>
                                    <p>
                                        We have the right, but not the obligation, to monitor any activity
                                        and content associated with the Website. We may investigate any
                                        reported violation of these Conditions or complaints and take any
                                        action that we deem appropriate (which may include, but is not
                                        limited to, issuing warnings, suspending, terminating or attaching
                                        conditions to your access and/or removing any materials from the
                                        Website)
                                    </p>
                                    <h4>Law</h4>
                                    <p>
                                        The Conditions will be exclusively governed by and construed in
                                        accordance with the laws of South Africa whose Courts will have
                                        exclusive jurisdiction in any dispute, save that we have the
                                        right, at our sole discretion, to commence and pursue proceedings
                                        in alternative jurisdictions
                                    </p>
                                    <h4>Updating of these Terms and Conditions</h4>
                                    <p>
                                        We reserve the right to change, modify, add to or remove from
                                        portions or the whole of these Terms and Conditions from time to
                                        time. Changes to these Terms and Conditions will become effective
                                        upon such changes being posted to this Website. It is the member’s
                                        obligation to periodically check these Terms and Conditions at the
                                        Website for changes or updates. The member’s continued use of this
                                        Website following the posting of changes or updates will be
                                        considered notice of the member’s acceptance to abide by and be
                                        bound by these Terms and Conditions, including such changes or
                                        updates
                                    </p>
                                    <h4>Severability</h4>
                                    <p>
                                        If any of the terms or conditions herein shall be deemed invalid,
                                        void, or for any reason unenforceable, that term or condition
                                        shall be deemed severable and shall not affect the validity and
                                        enforceability of any remaining term or condition.
                                    </p>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </>


            <Footer />
        </div>
    )
}
